import { components } from '../../data/cpts/components.js'

let visited = []
let visitedwires = []

const getSnappedElementsToBB = (snapped) => {
  const snappedElements = []
  snapped.forEach(item => {
    const codename = item.MS.substr(2, 2) === 'BB' ? item.PS.substr(2, 5) : item.MS.substr(2, 5)
    const idname = components.findByCodeName(codename.substr(0, 2)).idname
    const fullname = `${idname}_${Number(codename.substr(3, 2))}`
    if (snappedElements.indexOf(fullname) === -1) snappedElements.push(fullname)
  })
  return snappedElements
}

function changeSeatState (seats, compoId, state) {
  for (let i = 0; i < seats.length; i++) {
    const element = seats[i];
    if (element.name === compoId) {
      element.taken = state
      return
    }
  }
}

const state = {
  using: {},
  usingCounts: {},
  selected: {
    list: [],
    current: {
      el: null,
      id: '',
      type: ''
    }
  },
  snapped: []
}
const getters = {}
const mutations = {
  setNumberOfElcts (state, payload) {
    state.usingCounts = payload
  },
  /* set selected elct/component */
  addSelectedElct (state, payload) {
    // console.log('elct selected', payload)

    state.selected.current = payload
    state.selected.list.push(state.selected.current)
    this.commit('checkSensorType', payload.type)
  },
  removeSelectedElct (state, payload) {
    // console.log('elct unselected', payload)

    const idx = state.selected.list.findIndex(item => item.el === payload.el)
    state.selected.list.splice(idx, 1)
    if (state.selected.list.length) {
      state.selected.current = state.selected.list[state.selected.list.length - 1]
    } else {
      state.selected.current = { el: null, id: '', type: null }
    }
    this.commit('checkSensorType', state.selected.current.type)
  },
  deleteFromRootVue (state, payload) {
    const idx = this.$app.$children.findIndex(
      (child) => child.$el.id === payload
    )
    if (idx === -1) return
    const child = this.$app.$children[idx]
    if (this.state.sim.userData[child.namecode]) {
      delete this.state.sim.userData[child.namecode]
    }
    child.$destroy()
  },
  deleteSelectedAll (state) {
    if (!state.selected.list.length) return
    // state.selected.list.forEach(item => {
    //   this.commit('elct/deleteFromRootVue', item.id)
    //   item.el.remove()
    //   if (item.id.startsWith('wire-group')) {
    //     const groupNum = item.id.substr(10)
    //     this.commit('wire/deleteWireListById', groupNum)
    //   } else {
    //     this.commit('elct/removeUsingElct', { el: item.el, id: item.id })
    //   }
    // })
    for (let i = 0; i < state.selected.list.length; i++) {
      const item = state.selected.list[i];
      this.commit('elct/deleteFromRootVue', item.id)
      item.el.remove()
      if (item.id.startsWith('wire-group')) {
        const groupNum = item.id.substr(10)
        this.commit('wire/deleteWireListById', groupNum)
      } else {
        this.commit('elct/removeUsingElct', { el: item.el, id: item.id })
      }
    }
    this.commit('elct/removeUsingElcts')
    this.commit('elct/clearSelectedElctList')
  },
  // deleteConnetedWiresToBB (state, bbid) {
  //   this.commit('selectConnectedWires', bbid)
  //   visitedwires.forEach(id => {
  //     const el = document.getElementById(id)
  //     this.commit('elct/addSelectedElct', { el, id })
  //   })
  //   this.commit('elct/deleteSelectedAll')
  // },
  clearSelectedElctList (state) {
    state.selected.list.forEach(item => {
      item.el.classList.remove('selected')
    })
    state.selected.current = { el: null, id: '' }
    state.selected.list = []
  },
  /* set using elct/compoenent */
  addUsingElct (state, payload) {
    const obj = {}
    const attr = components.find('idname', payload.idname).attr
    if (!state.using[payload.name]) {
      state.using[payload.name] = {}
    }
    obj.attr = { degree: 0, pos: payload.pos, ...attr }

    state.using[payload.name][payload.id] = obj.attr

    state.usingCounts[payload.idname].limit -= 1
    state.usingCounts[payload.idname].totaluse += 1
    changeSeatState(state.usingCounts[payload.idname].seats, payload.id, true)
  },
  removeUsingElct (state, payload) {
    const idx = payload.id.indexOf('_')
    const idname = payload.id.substr(0, idx)
    const type = components.find('idname', idname).code.name
    if (!state.using[type]) return

    state.usingCounts[idname].limit += 1
    state.usingCounts[idname].totaluse -= 1
    changeSeatState(state.usingCounts[idname].seats, payload.id, false)
    
    delete state.using[type][payload.id]
    // if (!Object.keys(state.using[type]).length) delete state.using[type]
  },
  removeUsingElcts (state) {
  },
  assignUsingCounts (state, compClassId, compoId) {
    state.usingCounts[compClassId].limit -= 1
    state.usingCounts[compClassId].totaluse += 1
    changeSeatState(state.usingCounts[compClassId].seats, compoId, true)
  },
  dischargeUsingCounts (state, compClassId, compoId) {
    state.usingCounts[compClassId].limit += 1
    state.usingCounts[compClassId].totaluse -= 1
    changeSeatState(state.usingCounts[compClassId].seats, compoId, false)
  },
  updateResist (state, payload) {
    if (!state.using.RE[payload.id]) return
    state.using.RE[payload.id].resist = payload.resist
  },
  updateElctValues (state, payload) {
    state.using[payload.code][payload.id][payload.attr] = payload.val
  },
  updateElctsValues (state, payload) {
  },
  selectAllElcts (state) {
    Object.keys(state.using).forEach((key) => {
      Object.keys(state.using[key]).forEach((id) => {
        const el = document.getElementById(id)
        this.commit('elct/addSelectedElct', { el, id })
      })
    })
    this.commit('wire/selectAllWireGroups')
    // this.commit('elct/deleteSelectedAll')
  },
  selectConnectedWires (state, elctId, recursive = false) {
    if (visited.includes(elctId)) return
    visited.push(elctId)
    const groups = this.state.wire.group.list
    const keys = Object.keys(groups)
    keys.pop()
    keys.forEach(i => {
      const start = groups[i][0].name
      const end = groups[i][groups[i].length - 1].name
      if (start.startsWith(elctId) || end.startsWith(elctId)) {
        const wireId = `wire-group${i}`
        if (!visited.includes(wireId)) {
          visited.push(wireId)
          visitedwires.push(wireId)
        }
        if (!end.startsWith('Breadboard') && recursive) {
          const other = start.startsWith(elctId) ? groups[i][groups[i].length - 1].name : groups[i][0].name
          this.commit('elct/selectConnectedWires', other)
        }
      }
    })
  },
  styleSelectedElct (state, el) {
    const obj = { el, id: el.id, type: null }
    obj.type = components.find('idname', el.id.split('_')[0]).type
    el.classList.toggle('selected')

    // console.log(el.classList)

    if (el.classList.contains('selected')) {
      this.commit('elct/addSelectedElct', obj)
    } else {
      this.commit('elct/removeSelectedElct', obj)
    }
  },
  setConnectedStyle (state, startBB) {
    if (!visited) return
    if (startBB) {
      const snapped = getSnappedElementsToBB(state.snapped)
      snapped.forEach(item => visited.push(item))
    }
    for (let i = 0; i < visited.length; i++) {
      const id = visited[i]
      const idx = this.$app.$children.findIndex((child) => child.$el.id === id)
      if (idx === -1) continue
      const children = this.$app.$children[idx]
      const el = children.$el
      if (!el) continue
      if (el.id.startsWith('wire-group')) {
        this.commit('wire/styleSelectedWire', children)
      } else this.commit('elct/styleSelectedElct', el)
    }
    visited = []
    visitedwires = []
  },
  putElctOnVisited (elctId) {
    visited.push(elctId)
  },
  setSnappedSockets (state, payload) {
    const arr = []
    Object.keys(payload).forEach(key => {
      const innerkey = Object.keys(payload[key])[0]
      const bbpin = payload[key][innerkey].id.toString()
      arr.push({ PS: bbpin, MS: innerkey })
    })
    state.snapped = arr
  },
  rotateSelectedElct (state) {
    const selected = state.selected.list
    const snapped = getSnappedElementsToBB(state.snapped)
    if (selected.length) {
      selected.forEach((elct) => {
        if (snapped.includes(elct.id)) {
          this.commit('displayWarningBar', '브레드보드에 부착된 부품은 회전할 수 없습니다')
        } else if (elct.id.startsWith('Breadboard') && snapped.length > 0) {
          this.commit('displayWarningBar', '부착된 부품이 있는 브레드보드는 회전할 수 없습니다')
        } else if (!elct.id.startsWith('wire-group')) {
          const code = components.convertIdToCodeName(elct.id)
          state.using[code][elct.id].degree += 90
          window.gsap.to(`#${elct.id}`, {
            rotation: state.using[code][elct.id].degree,
            transformOrigin: 'center',
            onUpdate: () => {
              this.commit('wire/updateLines')
            }
          })
        }
      })
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations
}
